export const SlbOnlinePayments = {
    history: {
        date: "Date",
        paymentReference: "Payment reference #",
        invoiceReference: "Invoice / Quote #",
        amount: "Amount",
        receipt: "Receipt",
        view: "View",
        back: "Back",
        paymentDate: "Payment date",
        issues: "Having issues?",
        invoice: "Invoice #",
        quote: "Quote #"
    },
    invoice: {
        details: "Invoice Details",
        payment: {
            information: "Payment Information"
        },
        review: "Review & Submit payment",
        reference: "Reference To",
        invoice: "Invoice",
        quote: "Quote",
        currency: "Currency",
        amount: "Amount",
        bill: "Bill To",
        name: "Name",
        billing: "Billing address",
        invoicePlaceholder: "______________"
    },
    maintenance: {
        headline: "Quote headline name",
        validFrom: "Valid from",
        validTo: "Valid to",
        status: "Status",
        totalPrice: "Total price",
        withoutTax: "Without tax",
        download: "Download",
        renewal: "Renewal quote",
        signed: "Signed quote & PO",
        approve: "Approve",
        reject: "Reject",
        approved: "Approved",
        revision: "Revision {{version}}",
        uploadFiles: {
            title: "Approve Quote",
            description: "Please select the Signed quote and Purchase order files in the corresponding order. Only PDF files are allowed.",
            signed: "Signed quote",
            purchase: "Purchase order",
            browse: "Browse",
            error: "The files cannot be modified once submitted. Please ensure they are correct",
            success: "The files were upload successfully",
            failure: "There was an issue uploading the file. Please try again!",
            titleReject: "Reject Quote",
            descriptionReject: "Please provide your comments to reject the respective quote."
        },
        "slb.quote.status.offer": "Offer",
        "slb.quote.status.cancelled": "Cancelled",
        "slb.quote.status.replaced": "Replaced",
        "slb.quote.status.expired": "Expired",
        "slb.quote.status.buyer_accepted": "Buyer Accepted",
    }
}